/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc
 */

export const BasicBillableMetricTypeUsageTypename = 'com.hubspot.usagebasedbilling.experience.core.BasicBillableMetricTypeUsage';
export const DetailedBillableMetricTypeUsageTypename = 'com.hubspot.usagebasedbilling.experience.core.DetailedBillableMetricTypeUsage';
export let ComHubspotUsagebasedbillingExperienceCore;
(function (_ComHubspotUsagebasedbillingExperienceCore) {})(ComHubspotUsagebasedbillingExperienceCore || (ComHubspotUsagebasedbillingExperienceCore = {}));
export let ComHubspotUsagebasedbillingExperienceRpcModels;
(function (_ComHubspotUsagebasedbillingExperienceRpcModels) {})(ComHubspotUsagebasedbillingExperienceRpcModels || (ComHubspotUsagebasedbillingExperienceRpcModels = {}));
export const getCurrentUsageAndLimitRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getCurrentUsageAndLimit',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAC0o-_VNqarzBUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUsagePeriodUsageRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getUsagePeriodUsage',
  auth: 'app',
  fingerprint: '9kZhuu7l6itPWaHxJN6XHhUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNonChargeableUsagePeriodUsageRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getNonChargeableUsagePeriodUsage',
  auth: 'app',
  fingerprint: '9kZhuu7l6ivqQI7ABqAjlhUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalUsagePeriodUsageRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getHistoricalUsagePeriodUsage',
  auth: 'app',
  fingerprint: '9ZmDbyxdaB1zpEHY2ry6FBUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalNonChargeableUsagePeriodUsageRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getHistoricalNonChargeableUsagePeriodUsage',
  auth: 'app',
  fingerprint: '9ZmDbyxdaB1A4xfCLH8IxhUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalByFeatureCategoryRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getHistoricalByFeatureCategory',
  auth: 'app',
  fingerprint: 'dyhuTHx-LUVF1diw-w6m9xUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNonChargeableHistoricalByFeatureCategoryRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getNonChargeableHistoricalByFeatureCategory',
  auth: 'app',
  fingerprint: 'dyhuTHx-LUVF1diw-w6m9xUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllBillableMetricChargingEligibilityRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getAllBillableMetricChargingEligibility',
  auth: 'app',
  fingerprint: 'LfeFrQ2niNksJ8tSa4FGYxUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHistoricalByBillableMetricTypeRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getHistoricalByBillableMetricType',
  auth: 'app',
  fingerprint: 'IZToiqr50ASBoIiQLAZ9NxUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRateCardRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getRateCard',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAch7bIS2-iqRUqMzK9s8S2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getHubSpotCreditsOveragesCostRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getHubSpotCreditsOveragesCost',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABx_uDrMhOghTzZ4p7qKVma',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};